import React, { FC } from "react";
import { Button, message } from "antd";
import { YhBox } from "@/components/YhBox";
import { useDtpDetailModel } from "./dtpDetailModel";
import { RouterParamType } from "@/model/navModel";
import { IDtpTabEnum } from "../../dtpTypes";
import { BaseDetail } from "./base";
import { RelevanceTask } from "./task";
import { Extract } from "./extract";
import { Files } from "./files";
import { Approver } from "./approver";
import { PowerOfAttroney } from "./power0fAttroney";

export const TabBar: FC<RouterParamType> = (detailsInfo) => {
    const { tabActive, editFormVal, addFormVal, setTabActive } = useDtpDetailModel(({ tabActive, editFormVal, addFormVal }) => [tabActive, addFormVal, editFormVal]);
    const { saleCode } = detailsInfo.mode === "edit" ? editFormVal : addFormVal;
    const isEdit = detailsInfo.mode === "edit";

    //防止保存是表单拿不到， 在下面渲染
    const RenderTabItem = () => {
        switch (tabActive) {
            // case IDtpTabEnum.BASE_DETAIL:
            //     return <BaseDetail {...detailsInfo}/>;
            case IDtpTabEnum.POWER_OF_ATTRONEY:
                return <PowerOfAttroney {...detailsInfo} />;
            case IDtpTabEnum.EXTRACT:
                return <Extract {...detailsInfo} />;
            case IDtpTabEnum.RELEVANCE_TASK:
                return <RelevanceTask {...detailsInfo} />;
            case IDtpTabEnum.FILES:
                return <Files {...detailsInfo} />;
            case IDtpTabEnum.APPROVER_DETAIL:
                return <Approver {...detailsInfo} />;
            default:
                return <></>
        }
    }

    const classname = (type: IDtpTabEnum) => {
        return 'tab-item ' + (tabActive === type ? 'tab-active' : '')
    }
    const setTabActiveMiddle = (active: IDtpTabEnum) => {
        // console.log(detailsInfo)
        console.log(saleCode, editFormVal, addFormVal)
        if (!saleCode && !(active === IDtpTabEnum.BASE_DETAIL)) {
            message.error("请先选择外贸合同号");
            return false;
        }
        setTabActive(active)
    }
    const powerOfAttroneyStatus = editFormVal.status === "transport-status.init" || editFormVal.status === "transport-status.cancel"
    const action = <>
        <Button
            className={classname(IDtpTabEnum.BASE_DETAIL)}
            type="link"
            shape="round"
            onClick={() => setTabActiveMiddle(IDtpTabEnum.BASE_DETAIL)}
        >基本信息</Button>
        <Button
            hidden={!isEdit || powerOfAttroneyStatus}
            className={classname(IDtpTabEnum.POWER_OF_ATTRONEY)}
            type="link"
            shape="round"
            onClick={() => setTabActiveMiddle(IDtpTabEnum.POWER_OF_ATTRONEY)}
        >订舱委托书</Button>
        <Button
            hidden={!isEdit}
            className={classname(IDtpTabEnum.EXTRACT)}
            type="link"
            shape="round"
            onClick={() => setTabActiveMiddle(IDtpTabEnum.EXTRACT)}
        >提单管理</Button>
        <Button
            hidden={!isEdit}
            className={classname(IDtpTabEnum.RELEVANCE_TASK)}
            type="link"
            shape="round"
            onClick={() => setTabActiveMiddle(IDtpTabEnum.RELEVANCE_TASK)}
        >关联单据</Button>
        <Button
            hidden={!isEdit}
            className={classname(IDtpTabEnum.FILES)}
            type="link"
            shape="round"
            onClick={() => setTabActiveMiddle(IDtpTabEnum.FILES)}
        >附件管理</Button>
        <Button
            hidden={!isEdit}
            className={classname(IDtpTabEnum.APPROVER_DETAIL)}
            type="link"
            shape="round"
            onClick={() => setTabActiveMiddle(IDtpTabEnum.APPROVER_DETAIL)}
        >审批明细</Button>
    </>

    return (
        <>
            <YhBox
                style={{ paddingBottom: 0, marginBottom: "10px" }}
                action={action}
            />
            <div hidden={tabActive !== IDtpTabEnum.BASE_DETAIL}>
                <BaseDetail {...detailsInfo} />
            </div>
            <RenderTabItem />
        </>
    )
}